var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item py-2 px-0",on:{"click":function($event){return _vm.$bus.$emit('toggle-tenant-settings')}}},[_vm._v("Settings")])
}
var staticRenderFns = []

export { render, staticRenderFns }